/**
 * Returns page origin of the specified window object, or the current
 * window.location.
 *
 * The .origin property on window.location is not available everywhere (notably
 * IE11), so we have to construct it manually.
 *
 *  @param {Object} winLoc location object
 *  @param {String} winLoc.hostname
 *  @param {String} winLoc.origin
 *  @param {String} winLoc.port
 *  @param {String} winLoc.protocol
 *  @returns {String} current page origin
 */
export function getOrigin(winLoc) {
  if (winLoc || typeof window !== 'undefined') {
    const { hostname, origin, port, protocol } = winLoc || window.location;
    return origin || `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  }
  return '';
}

/**
 * Returns current page URL without any query params or fragment identifier.
 *
 *  @param {Object} winLoc location object
 *  @param {String} winLoc.hostname
 *  @param {String} winLoc.origin
 *  @param {String} winLoc.port
 *  @param {String} winLoc.protocol
 *  @param {String} path
 *  @returns {String} current page URL
 */
export function getCurrentWindowUrl(winLoc, path) {
  return `${getOrigin(winLoc)}${path}`;
}
